module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "cn"
  }, [_c('a', {
    attrs: {
      "href": "#/APerfectSecreteBook2"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "ahaft"
  }, [_vm._v("Two months later . . . ")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("The sunlight of early autumn filtered through the clear windowpanes and made passing shadows on the wide fir floor of the Bender far4mhouse. The family was gathered for a hearty meal, and the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("gut")]), _vm._v(" smells of cooking mingled with robust conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“I tell you that it’s downright odd, that’s what.” Rose’s father gestured with his fork to the lunch table at large. “Two of our hens—our best layers, mind you—a goat from the Lamberts’, and the sheets from old Esther Mast’s clothesline. All of it missing, and dozens of other things from the community over the past few months. I say there’s a thief hereabouts, and that’s the truth.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Rose’s mother calmly passed the platter of sauerkraut and kielbasa to Rose’s two older brothers to take seconds. Then she offered the fresh platter of airy biscuits to "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Aenti")]), _vm._v(" Tabitha, Father’s sister, and nodded her head as her husband sputtered himself out.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Maybe it’s a Robin Hood type of thief,” "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Aenti")]), _vm._v(" Tabitha ventured, her brown eyes shining. At fifty, she often seemed as young as a girl to Rose with all of her romantic ideas and flights of fancy. Yet her suggestion stilled Rose’s hand for a moment over the saltshaker. What would it be like to meet such a romantic figure of a man? Dark and mysterious in nature . . . ")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Abram Bender shook his head at "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Aenti")]), _vm._v(" Tabitha. “Tabby, you always have had a heart of gold—looking for the best in others. But Rob in the Hood, like the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Englisch")]), _vm._v(" folktale? Taking from the rich to give to the poor? Who’s poor in our community? Don’t we all see to each other? "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Nee")]), _vm._v(", this is just a thief, plain and simple. And I don’t like it one bit.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“The weather’ll change over the next month or so,” Ben remarked over a forkful of boiled potatoes. “Any thief is likely to drop off in his ways once there’s snow on the ground to track him.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Or her,” Rose said, for some reason wanting to provoke.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“What?” her father asked.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“I said "), _c('em', {
    staticClass: "i"
  }, [_vm._v("her")]), _vm._v(". Your thief could be a female, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Daed")]), _vm._v(".” She didn’t really think the thief was female, yet she had a strange urge to enter the suggestion into her father’s mind.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Her "), _c('em', {
    staticClass: "i"
  }, [_vm._v("daed")]), _vm._v(" gave a shout of laughter, then resumed eating. Ben turned to her with a smile while her other brother, James, just rolled his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Rose, no woman in her right mind is going to go thieving about,” "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Daed")]), _vm._v(" said. “It’s a "), _c('em', {
    staticClass: "i"
  }, [_vm._v("gut")]), _vm._v(" thing you’re marrying Luke come December. Maybe he’ll settle down some of your wild ideas.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Perhaps.” She smiled, her green eyes flashing heat for a brief second.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Well,” Ben interjected, “Rose’s "), _c('em', {
    staticClass: "i"
  }, [_vm._v("narrisch")]), _vm._v(" thoughts aside—there’s a storm due tonight, supposed to be a doozy.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“"), _c('em', {
    staticClass: "i"
  }, [_vm._v("Ya")]), _vm._v(", I heard.” Father rose from the table and hitched up his suspenders. “Come on, boys. We’d best tighten down a few things.” He bent to pat "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Mamm")]), _vm._v("’s shoulder. “"), _c('em', {
    staticClass: "i"
  }, [_vm._v("Danki")]), _vm._v(" for lunch.” Then he pinched Rose’s cheek fondly. “And no more foolish thoughts from you, my miss. Remember, you’re to be a married woman soon.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Rose didn’t respond. She toyed with her fork instead, making a mash of the potato as an idea began to take shape in her head.")]), _vm._v(" "), _c('p', {
    staticClass: "hb"
  }, [_vm._v("•••")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("As Rose cleared the lunch table mechanically, she avoided her "), _c('em', {
    staticClass: "i"
  }, [_vm._v("aent")]), _c('em', {
    staticClass: "i"
  }, [_vm._v("i")]), _c('em', {
    staticClass: "i"
  }), _vm._v("’s eagle eyes. Ever since she’d been little, she’d felt as though "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Aenti")]), _vm._v(" Tabby could see the subdued thoughts churning inside her head, and just for a moment she wanted to debate the merits of her plan undisturbed. Still, she knew the intent look on her aunt’s face and had to admit that the older woman’s intuition had fended off trouble for her many a time. But today—something was different. Today Rose "), _c('em', {
    staticClass: "i"
  }, [_vm._v("wanted")]), _vm._v(" trouble. She drew a sharp breath at the hazardous thought, but the idea fit with her nature of late. It seemed as though her spirit had grown more restless, less satisfied with life, ever since she’d accepted Luke’s proposal. She’d tried to pray about it, stretching her feelings out before the Lord for guidance, but nothing had come to her.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Aenti")]), _vm._v(" Tabby caught her eye in an unguarded moment as they washed and wiped the dishes. “I’d like to see you in my room, Rose, after we clean up a bit. If you don’t mind?”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Um . . . sure, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Aenti")]), _vm._v(" Tabby, but I have to hurry. I’m going to bake some pies this afternoon.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Bake? Pies?” Her aunt and "), _c('em', {
    staticClass: "i"
  }, [_vm._v("mamm")]), _vm._v(" uttered the questions in unison, and Rose concentrated on dabbing at a nonexistent spot on a dish. The whole family knew that she was a hard worker, to be sure, but baking was not a skill that she possessed or an activity she particularly enjoyed.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“"), _c('em', {
    staticClass: "i"
  }, [_vm._v("Ya")]), _vm._v("."), _c('em', {
    staticClass: "i"
  }, [_vm._v("”")]), _vm._v(" She nodded vigorously, forcing a soft curl to spring loose from the back of her "), _c('em', {
    staticClass: "i"
  }, [_vm._v("kapp")]), _vm._v(". “I need to practice, you know? Luke likes a "), _c('em', {
    staticClass: "i"
  }, [_vm._v("gut")]), _vm._v(" apple pie, or perhaps blueberry.” She stretched to put the plate away in the cupboard. “But I’ll be glad to come and talk with you before I start.”")]), _vm._v(" "), _c('p', {
    staticClass: "hb"
  }, [_vm._v("•••")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Aunt Tabby, who had never married, lived with the Benders and was a cherished part of the home and family. Rose and her brothers often sought the sanctuary of their aunt’s room for advice, comfort, or a smuggled sweet long after supper. But Rose knew that she had been distinctly absent lately from any visits with her beloved "), _c('em', {
    staticClass: "i"
  }, [_vm._v("aenti")]), _vm._v(" and mentally prepared to face what might be some pointed, but truth-provoking, questions about herself and Luke.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Aunt Tabby sank down onto the comfortable maple bed with its patchwork quilt and patted a space next to her. “"), _c('em', {
    staticClass: "i"
  }, [_vm._v("Kumme")]), _vm._v(" and sit, Rosie.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Rose blew out a breath, then came forward to relax into the age-old comfort of the well-turned mattress. She half smiled at her "), _c('em', {
    staticClass: "i"
  }, [_vm._v("aenti")]), _vm._v(", remembering times she’d jumped on the same bed and had once taken a header that nearly landed her in the windowsill. But that was childhood past—long past, or so it seemed to her heart.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“I’ll not keep you long, Rose, but I want to ask—why did you agree to marry Luke?”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("The question was even more probing than she’d braced for, and a thousand answers swirled in her mind.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Luke. Why did you accept his proposal?”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Well . . . because he’s . . . we’re . . . we’ve always been best friends.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Aunt Tabby frowned. “I’ve never married, child, but I do wonder if that is reason enough to build a life together.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Rose said, “It’s made both of the families happy.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“That’s true, but what about you? Are you happy?”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("There was a long, disconsolate silence that wrung Rose’s heart as her aunt touched her shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“I’m supposed to be happy,” Rose said, thinking hard.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“"), _c('em', {
    staticClass: "i"
  }, [_vm._v("Ya")]), _vm._v(", that’s true.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“I just—I expect too much, I guess. Like wanting some kind of—I don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Like wanting someone mysterious and romantic?”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Rose gazed in surprise at her "), _c('em', {
    staticClass: "i"
  }, [_vm._v("aenti")]), _vm._v(", who laughed out loud.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“I was young once too, and I think it’s perfectly normal to want more from a relationship than just friendship. But maybe—maybe there’s more to Luke Lantz than meets the eye. Have you thought of that?”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Rose shrugged as her aunt cleared her throat. “Luke’s father—well, we courted some. He was always shy, but then . . . well. He had it in him to do some fine kissing now and then.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Rose stared at her "), _c('em', {
    staticClass: "i"
  }, [_vm._v("aenti’")]), _vm._v("s flushed face. “You and Matthew Lantz? "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Aenti")]), _vm._v(" Tabby—I never knew you dated him. Why didn’t you marry him?”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“It wasn’t what the Lord wanted for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Rose marveled at the simple statement. She knew her people lived by the will of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Derr")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Herr")]), _vm._v(", but to give up a relationship because of faith was difficult for her to comprehend. She knew she had spiritual miles to go before she would make a decision like that.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Haven’t you ever regretted it? Not even when—well, when Laura Lantz died of the influenza? You’re still young, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Aenti")]), _vm._v(" Tabby. Maybe you and Mr. Lantz could—”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("“Nee")]), _c('em', {
    staticClass: "i"
  }, [_vm._v(",")]), _c('em', {
    staticClass: "i"
  }, [_vm._v("”")]), _vm._v(" the older woman gently contradicted. “I’ve never regretted it, not even when Laura died. In truth, I believe I would have regretted more if I had not obeyed what I felt was the Lord’s leading. And just think—had I married Matthew, there would be no Luke for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Rose frowned. “"), _c('em', {
    staticClass: "i"
  }, [_vm._v("Ya")]), _vm._v(", you’re right.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“So, you will try, Rosie? To see all there is of him?” Her aunt gave her a hug.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“"), _c('em', {
    staticClass: "i"
  }, [_vm._v("Ya, Aenti")]), _vm._v(" Tabby—all that there is.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51940d58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/APerfectSecreteBook8.vue
// module id = 81
// module chunks = 0